import React from 'react'
import { Button, Chip, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField, Tooltip } from '@mui/material'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import RefreshIcon from '@mui/icons-material/Refresh'
import { sectionSx, todayInputValue } from '../cashflowUtils'

export default function StoreDateFilter({
	date,
	isAdminLike,
	loadCashflow,
	selectedStoreId,
	selectedStoreName,
	setDate,
	setSelectedStoreId,
	stores,
}) {
	const today = todayInputValue()

	return (
		<Paper elevation={0} sx={{ ...sectionSx, mb: 2 }}>
			<Grid container spacing={2} alignItems='center'>
				<Grid item xs={12} md={isAdminLike ? 5 : 7}>
					{isAdminLike ? (
						<FormControl fullWidth size='small'>
							<InputLabel>Cửa hàng</InputLabel>
							<Select label='Cửa hàng' value={selectedStoreId} onChange={(event) => setSelectedStoreId(event.target.value)}>
								{stores.map((store) => (
									<MenuItem key={store._id} value={store._id}>
										{store.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					) : (
						<Chip icon={<AccountBalanceIcon />} label={selectedStoreName} sx={{ fontWeight: 700 }} />
					)}
				</Grid>
				<Grid item xs={8} md={3}>
					<TextField
						fullWidth
						size='small'
						type='date'
						label='Ngày'
						value={date}
						onChange={(event) => setDate(event.target.value > today ? today : event.target.value)}
						InputLabelProps={{ shrink: true }}
						inputProps={{ max: today }}
					/>
				</Grid>
				<Grid item xs={4} md={2}>
					<Tooltip title='Tải lại'>
						<Button fullWidth variant='outlined' startIcon={<RefreshIcon />} onClick={loadCashflow}>
							Tải
						</Button>
					</Tooltip>
				</Grid>
			</Grid>
		</Paper>
	)
}
